import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54675a80"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag--gray-30",
  "data-suggest-placement": ""
}, " Only at International ", -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "des-content flex-full"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  key: 0,
  class: "circle-content flex-row"
};
const _hoisted_6 = ["onClick"];
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductItem',
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    productClass: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 280
    }
  },
  setup(__props) {
    const imgIndex = ref(0);
    return (_ctx, _cache) => {
      const _component_RouterLink = _resolveComponent("RouterLink");
      return _openBlock(), _createElementBlock("div", {
        class: "product-item flex-col",
        style: _normalizeStyle('width: ' + __props.width + 'px;')
      }, [_createVNode(_component_RouterLink, {
        to: __props.item.link ? __props.item.link + '/' + __props.productClass : '',
        class: "router-link"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "product-img",
          style: _normalizeStyle('background-image: url(' + (__props.item.style ? __props.item.style[imgIndex.value].img : __props.item.img) + ');width: ' + __props.width + 'px;')
        }, _hoisted_2, 4)]),
        _: 1
      }, 8, ["to"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(__props.item.title)), 1), __props.item.style && __props.item.style.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.style, (item0, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "circle",
          key: i,
          style: _normalizeStyle('background-color: ' + item0.color),
          onClick: $event => imgIndex.value = i
        }, null, 12, _hoisted_6);
      }), 128))])) : _createCommentVNode("", true)])], 4);
    };
  }
});